import React from "react";
import PropTypes from "prop-types";
import DashboardLayout from "ui/LayoutContainers/DashboardLayout";
import DashboardNavbar from "ui/Navbars/DashboardNavbar";

const LayoutWrapper = ({ children }) => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {children}
    </DashboardLayout>
  );
};

export default LayoutWrapper;
LayoutWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
